import React from 'react';

import {
  SearchContainer,
  SearchDetail,
  SearchWrapper,
  FilterSorter,
  SearchHead,
  Sort,
  View,
  Sorter,
  Filter
} from './styles';
import Search from '../../Search/Search';
import MultiSelect from '../../../Components/MultiSelect/MultiSelect';
import ToggleSwitch from '../../../../../CommonComponents/ToggleSwitch/ToggleSwitch';
import Filters from '../../Filters/Filters';
import FilterModal from '../../FilterModal/FilterModal';
import { amountFormatter } from '../../../utils';
import PropTypes from "prop-types";

const SearchWeb = ({
  options,
  filters,
  changeState,
  filterType,
  searched,
  restored,
  sorted,
  assetsDetails,
  value,
  selectedVal,
  clicked,
  closed,
  selected,
  reset,
  typed
}) => {
  return (
    <SearchContainer>
      <SearchWrapper>
        <Search
          placeholder='Search by Client Name or Fund Name or Acc.No.'
          searched={searched}
          restored={restored}
          accSearch={true}
        />
        <SearchDetail>
          Displaying <span>{assetsDetails && assetsDetails.accounts}</span>{' '}
          accounts, assets worth with{' '}
          <span> {amountFormatter(assetsDetails.assets)}</span>
        </SearchDetail>
      </SearchWrapper>
      <FilterSorter>
        <Sorter>
          <Sort>
            <SearchHead>Sort By</SearchHead>
            <MultiSelect
              options={options}
              value={value}
              selectedVal={selectedVal}
              sorted={value => sorted(value)}
              defaultValue={'lastNameAsc'}
              mode='default'
            />
          </Sort>
          <View secondary>
            <SearchHead>View</SearchHead>
            <ToggleSwitch filterType={filterType} changeState={changeState} />
          </View>
        </Sorter>
        <Filter>
          <Filters filters={filters} clicked={clicked} />
          <FilterModal
            typed={typed}
            reset={reset}
            selected={selected}
            filters={filters}
            closed={closed}
          />
        </Filter>
      </FilterSorter>
    </SearchContainer>
  );
};
SearchWeb.propTypes = {
  options:PropTypes.arrayOf(PropTypes.object),
  filters:PropTypes.arrayOf(PropTypes.object),
  changeState:PropTypes.func,
  filterType:PropTypes.string,
  searched:PropTypes.func,
  restored:PropTypes.func,
  sorted:PropTypes.func,
  value:PropTypes.string,
  selectedVal:PropTypes.string,
  clicked:PropTypes.func,
  reset:PropTypes.func,
  closed:PropTypes.func,
  selected:PropTypes.func,
  assetsDetails:PropTypes.object
};
export default SearchWeb;
